export class BasemapGalleryItemDataProps {
    id: string;
    title: string;
    tags: string[];
    thumbnailUrl?: string;
    isOrthophoto?: boolean;
}

export class BasemapGalleryItemData {
    id: string;
    title: string;
    tags: string[];
    thumbnailUrl: string;
    isOrthophoto: boolean;
    isPlaceholder: boolean;

    constructor(props?: BasemapGalleryItemDataProps) {
        if (props) {
            Object.assign(this, props);
        }
    }
}
